import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../../agents/angular/models/agent.model";

export class ResourceAllocationsAgentBulkAssignmentTableRowComponent implements IController {

  agent: AgentModel;
  onAssign: Function;

  constructor() {
  }

}

angular
  .module('bringoz.admin.resources')
  .component('resourceAllocationsAgentBulkAssignmentTableRow', {
    bindings: {
      agent: '<?',
      onAssign: '&'
    },
    template: require('./resource-allocations-agent-bulk-assignment-table-row.html').default,
    controller: ResourceAllocationsAgentBulkAssignmentTableRowComponent
  });
